<template>
    <div id="home" :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto" v-hammer:swipe.up="onSwipeUp">
        
        <div class="hometitle" :style="{width:titleW+'px',top:titleT+'px',left:titleL+'px'}" >
            <img :src="imgPath+'title.png'" alt="">
        </div>
        <div class="homecompany" :style="{width:companyW+'px',top:companyT+'px',left:companyL+'px'}">
            <img :src="imgPath+'company.png'" alt="">
        </div>
        <div class="yuan" :style="{width:yuanW+'px',height:yuanW+'px',bottom:yuanB+'px',left:yuanL+'px'}" @click="onSwipeUp">
            <div class="yuan-frame">
                
            </div>
            <div class="yuan-alow">
                <img :src="imgPath+'alow.png'" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath
        }
    },
    created(){
        this.getViewScale();
        this.titleW = (590/750)*this.clientW;
        this.titleT = (94/1334)*this.clientH;
        this.titleL = (80/750)*this.clientW;
        this.companyW = (590/750)*this.clientW;
        this.companyT = (614/1334)*this.clientH;
        this.companyL = (80/750)*this.clientW;
        this.yuanW = (103/750)*this.clientW;
        this.yuanB = (34/1334)*this.clientH;
        this.yuanL = (326/750)*this.clientW;
    },
    mounted() {
    },
    methods:{
        getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        onSwipeUp(){
            this.$router.push({path:"/colum"})
        }
    }
}
</script>
<style lang="less" scoped>
@base:46.875rem;
#home{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/bg.png);
    background-size: 100% 100%;
    position: relative;
    .hometitle{
        position: absolute;
        img{
            width: 100%;
        }
    }
    .homecompany{
        position: absolute;
        img{
            width: 100%;
        }
    }
    .yuan{
        position: absolute;
        border-radius: 50%;
        .yuan-alow{
            overflow: hidden;   
            width: 78%;
            height: 78%;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            img{
                position: absolute;
                // width: 66/@base;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                animation: 2s alow 0.5s infinite linear;
            }
        }
        
        .yuan-frame{
            width: 100%;
            height: 100%;
            position: absolute;
            background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/yuan.png);
            background-size: 100% 100%;
            animation: xuan 2s infinite linear;
            
        }
        
    }
}
@keyframes xuan{
    0%{
        transform: rotate(0);
    }
    100%{
        transform: rotate(360deg);
    }
}
@keyframes alow{
    0%{
        transform: translate(-50%,100%);
        opacity: 0;
    }
    50%{
        transform: translate(-50%,-50%);
        opacity: 1;
    }
    100%{
        transform: translate(-50%,-200%);
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue